import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=2bbf8f37"
import script from "./Zone.vue?vue&type=script&lang=js"
export * from "./Zone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports